// faqData.js
import snipperIcon from "./../assets/shipped.png";
import exchangesIcon from "./../assets/exchanges.png";
import ordersIcon from "./../assets/orders.png";
import productsIcon from "./../assets/perfume.png";
const faqData = [
  {
    imgSrc: snipperIcon,
    link: "",
    text: "Shipping & Delivery",
    textKey: "shipping",
    faqs: [
      {
        id: "1",
        question: "What Happens After I Place An Order?",
        url: "",
        answer:
          "A confirmation e-mail will be sent to you of acceptance your order, after that we will handle your product, and it will reach you with our contracted shipping companies. ( DHL, UPS and FEDEX) are our Prime Cargo companies",
      },
      {
        id: "2",
        question: "What Are The Shipping Fees?",
        url: "",
        answer:
          "You will not be concerned with shipping fees, Shipping fees are a gift from Mukemel Family to our beloved customers.",
      },
      {
        id: "3",
        question: "How Will I Get My Order? ",
        url: "",
        answer:
          "After the order is placed and your payment is verified, we process sculptures orders within 3 business days. Business days are Mondays till Fridays, excluding holidays. Please note that we do not process nor ship orders on Saturdays, Sundays and on Turkey Holidays. Orders placed on these days will be processed the following business day. Delivery is dependent on our carriers (DHL, UPS & FEDEX) and can be subject to weather delays. Orders may take longer than usual during sale seasons such as Black Friday, Cyber Monday,….etc.",
      },
    ],
  },
  {
    imgSrc: exchangesIcon,
    link: "",
    text: "Exchanges & Returns",
    textKey: "returns",
    faqs: [
      {
        id: "1",
        question: "What I Should Do When My Product Was Delivered Broken?",
        url: "",
        answer:
          "Our policies state that a customer who received their package broken must contact us 24 hours after the package was delivered Except for PERFUME, after that period we consider it to have been safely delivered. and we take no responsibility for this matter.",
      },
      {
        id: "2",
        question: "What Should I Do When I Did Not Like My Product?",
        url: "",
        answer:
          "Our policies state that we offer customers returns (EXEPT OF PERFUME ORDERS) on our products within 14 days of the shipping date. If 14 days have gone, unfortunately we can’t offer you a refund.Please note that there is a fees will be deducted from your order, each case will be considered separately.To be eligible for a return, the product must be unused and in the same condition that you received it. It must also be in the original packaging and the tag must be attached.Also the Cargo and Customs fees belong to the buyer.",
      },
      {
        id: "3",
        question:
          "Can I Return My Product If I Have My Order With Personalization?",
        url: "",
        answer:
          "We do not accept any return if the product was ordered with any Personalization.",
      },
    ],
  },
  {
    imgSrc: ordersIcon,
    link: "",
    text: "Product Orders",
    textKey: "orders",
    faqs: [
      {
        id: "1",
        question: "Wholesale Avalability?",
        url: "",
        answer:
          "We gladly offer wholesale purchases, for more information you can easily email us on customer.support@mukemel.com",
      },
      {
        id: "2",
        question: "What Are The Payment Methods?",
        url: "",
        answer:
          "We use authenticated Payment gateway, a reputable and secure payment, for processing all our online transactions.",
      },
      {
        id: "3",
        question: "What I Should Do When The A Product Out Of Stock ?",
        url: "",
        answer:
          "For products that are sold out, please Contact us on our Email: customer.support@mukemel.com.for us to add your e-mail address to the Waitlist. Once the product is back in stock, you will be notified via e-mail.",
      },
    ],
  },
  {
    imgSrc: productsIcon,
    link: "",
    text: "Perfume Policies",
    textKey: "perfume",
    faqs: [
      {
        id: "1",
        question: "What Are The Payment Methods?",
        url: "",
        answer:
          "We use authenticated Payment gateway, a reputable and secure payment, for processing all our online transactions.",
      },
      {
        id: "2",
        question: "Wholesale Avalability?",
        url: "",
        answer:
          "We gladly offer wholesale purchases, for more information you can easily email us on customer.support@mukemel.com",
      },
      {
        id: "3",
        question: "What Happens After I Place An Order?",
        url: "",
        answer:
          "A confirmation e-mail will be sent to you of acceptance your order, after that we will handle your product, and it will reach you with our contracted shipping companies. ( DHL, UPS and FEDEX) are our Prime Cargo companies",
      },
      {
        id: "4",
        question: "What Are The Shipping Fees?",
        url: "",
        answer:
          "You will not be concerned with shipping fees, Shipping fees are a gift from Mukemel Family to our beloved customers.",
      },
      {
        id: "5",
        question: "How Will I Get My Perfume Order?",
        url: "",
        answer:
          "After the order is placed and your payment is verified, we will start the production faze for your perfume order and it will reach you in 14 business days. Business days are Mondays till Fridays, excluding holidays. Please note that we do not process nor ship orders on Saturdays, Sundays and on Turkey Holidays. Orders placed on these days will be processed the following business day. Delivery is dependent on our carriers (DHL, UPS & FEDEX) and can be subject to weather delays. Orders may take longer than usual during sale seasons such as Black Friday, Cyber Monday,….etc.",
      },
      {
        id: "6",
        question: "What I Should Do When The A Product Out Of Stock ? ",
        url: "",
        answer:
          "We do not hold any stock of the PERFUME and each product we produce it individually for the customers, that is why we take 14 working days to deliver the products to our customer.",
      },
      {
        id: "7",
        question: "What I Should Do When My Product Was Delivered Broken?",
        url: "",
        answer:
          "Our policies state that PERFUME orders will not be delivered broken because it’s prepared by each order separately and in its protected box and there is no possibility of it to arrive broken.",
      },
      {
        id: "8",
        question: "What I Should Do When I Did Not Like My Perfume Order?",
        url: "",
        answer:
          "Our policies state that we offers returns on our products customers within 48 hours of the shipping date. If 48 hours have gone by, unfortunately we can’t offer you a refund.Please note that there is a fees will be deducted from your order, each case will be considered separately.To be eligible for a return, There is a heat-sealed sticker on the top of the perfume box! If you wish to return the product, the box must remain unopened. If the heat-sealed sticker is broken, returns will not be accepted!We have also sent you 2 testers as a gift from us so you can smell the fragrance — and they are yours to keep in any case.Also the Cargo and Customs fees are belong to the buyer.",
      },
      {
        id: "9",
        question:
          "Can I Return My Product If I Have My Order With Personalization?",
        url: "",
        answer:
          "We do not accept any return if the product was ordered with any Personalization.",
      },
    ],
  },
];

export default faqData;
